export function isInStorybook() {
	return document.querySelector('body')!.classList.contains('sb-show-main');
}

export function isInStorybookStory(hostElement: HTMLElement) {
	return !!hostElement.closest('.sb-story');
}
